import axios from 'axios';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: ''
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // ✅ STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const businessDayService = {
  getBusinessDays
};

// --- GET BUSINESS DAYS ---
async function getBusinessDays(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/api/dataview/business-days', payload, requestOptions);

  return response.data;
}
